import React, { useContext, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Handle, useReactFlow } from "react-flow-renderer";
import { NodesContext } from "../provider/IvrContext";
import AudioPreviewModal from "../Helpers/AudioPreviewModel";
import { toast } from 'react-toastify';


const PlayNode = ({ data, id }) => {
    const { setNodes } = useReactFlow();

    const { updateNodeData, onRemove, audioList } = useContext(NodesContext)
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [errors, setErrors] = useState({});
    const [playModalOpen, setPlayModalOpen] = useState(false);


    // ✅ derive from node data
    const action = data.action || {};
    const audioId = action.id || "";
    const audioUrl = action.audio || "";
    const audioName = action.name || "";

    const [draftAction, setDraftAction] = useState(action);


    const updateNode = (updates) => {
        updateNodeData(id, updates);
    };

    const handleAudioChange = (e) => {
        const selected = audioList.find(
            (a) => a.id.toString() === e.target.value
        );

        if (!selected) return;

        setDraftAction({
            type: "play",
            id: selected.id,
            audio: selected.prompt_url,
            duration: selected.prompt_duration || "",
            name: selected.prompt_name,
        });
    };


    const openModal = () => {
        setDraftAction(action);
        setErrors({});
        setModalIsOpen(true);
    };

    const handleClose = () => {
        setDraftAction(action);
        setErrors({});
        setModalIsOpen(false);
    };

    const handleSave = () => {
        if (!draftAction?.id) {
            setErrors({ audio: "Audio is required" });
            return;
        }

        updateNode({
            action: draftAction,
        });

        toast.success("Details updated successfully.");
        setModalIsOpen(false);
    };


    const handleRemoveNode = () => {
        if (data.parent === "gather Node" && data.idToRemove) {
            setNodes((nodes) =>
                nodes.map((node) => {
                    if (!node.data.selectedHandles) return node;

                    const updatedHandles = { ...node.data.selectedHandles };
                    const updatedSmsData = { ...node.data.smsData }
                    delete updatedHandles[data.idToRemove];
                    if (updatedSmsData) {
                        const parts = data.idToRemove.split('-');
                        const handleIndex = parts[parts.length - 1];
                        if (handleIndex) {
                            const smsKey = `DTMF_${handleIndex}`;
                            delete updatedSmsData[smsKey]
                        }
                    }
                    return {
                        ...node,
                        data: { ...node.data, selectedHandles: updatedHandles, smsData: updatedSmsData },
                    };
                })
            );
        }
        onRemove(id)
    };

    return (
        <div style={{ position: "relative", width: "65px", height: "40px" }}>
            <div
                className="ivr-flow-node"
                style={{
                    position: "absolute",
                    top: 8,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: "1.5px solid #007bff",
                    borderRadius: "10px 10px 0 10px",
                    background: "#fff",
                    zIndex: 3,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "4px",
                    fontSize: "11px",
                }}
            >
                <Handle type="target" position="top" style={{ background: "#007bff" }} />
                <Handle type="source" position="bottom" style={{ background: "#007bff" }} />

                <span className="ivr-flow-node-label" style={{ fontSize: "10px", fontWeight: "bold", textTransform: "capitalize" }}>
                    {data.label}
                </span>

                <div style={{ display: "flex", gap: "5px", paddingTop: "2px" }}>
                    <i
                        className="fa fa-cog ivr-flow-node-icon"
                        style={{ color: "#007bff", cursor: "pointer" }}
                        onClick={openModal}
                    />
                    <i
                        className="fa fa-trash ivr-flow-node-icon"
                        style={{ color: "#007bff", cursor: "pointer" }}
                        onClick={handleRemoveNode}
                    />
                    {audioUrl && (
                        <i
                            className="fa fa-play ivr-flow-node-icon"
                            style={{ color: "#28a745", cursor: "pointer" }}
                            title="Play audio"
                            onClick={() => setPlayModalOpen(true)}
                        />
                    )}
                </div>
            </div>

            <Modal
                size="lg"
                show={modalIsOpen}
                onHide={handleClose}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Play</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Select Audio</Form.Label>
                            <Form.Control
                                as="select"
                                value={draftAction?.id || ""}
                                onChange={handleAudioChange}
                            >
                                <option value="">Select Audio</option>
                                {audioList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.prompt_name}
                                    </option>
                                ))}
                            </Form.Control>
                            {errors.audio && <Form.Text className="text-danger">{errors.audio}</Form.Text>}
                        </Form.Group>
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={handleSave}>Save</Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <AudioPreviewModal
                show={playModalOpen}
                onClose={() => setPlayModalOpen(false)}
                audioUrl={audioUrl}
                title={audioName}
            />

        </div>
    );
};

export default PlayNode;
